import { render } from "./TileInvoices.vue?vue&type=template&id=55ba7037&scoped=true&ts=true"
import script from "./TileInvoices.vue?vue&type=script&lang=ts"
export * from "./TileInvoices.vue?vue&type=script&lang=ts"

import "./TileInvoices.vue?vue&type=style&index=0&id=55ba7037&lang=scss&scoped=true"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55ba7037"]])

export default __exports__